export default (ctx, key) => {
  let strings = {
    "wrong_entries": "Please check that you write your old password correctly and follow new password instructions",
    "successfully_changed": "Your password successfully changed!",
    "validate_password": "Passwords don't match!",
    "wrong_old_password": "Your current password is incorrect!",
    "wrong_rules": "your new password must be at least 6 digits"
  }
  return strings[key]
}